<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <div class="pa-4">
    <h2>{{ $t('dishInfoExport') }}</h2>
    <v-divider class="my-4"/>


    <div
      v-if="!errorExist"
    >
      <p

        class="my-8 pa-8 text-center"
        style="background-color: lightskyblue"
      >
        <v-icon>mdi-clock</v-icon>
        {{ $t('uploadFile') }}
        <v-icon>
          mdi-clock-outline
        </v-icon>
        {{ $t('exportFile') }}
      </p>
      <div
        style="border-radius: 15px; border: dashed 1px grey; "
        class="d-flex justify-center align-center mx-6 py-6"
        :class="{ 'grey lighten-2': dragover }"
        @drop.prevent="onDrop"
        @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true"
        @dragleave.prevent="dragover = false"
      >
        <div
          style="position: relative"
        >
          <div
            v-if="!selectFile"
            class="text-center my-4"
          >
            <v-icon
              size="60"
            >
              mdi-cloud-upload
            </v-icon>
          </div>

          <div
            v-else
            style="display: grid; grid-template-columns: 3fr 3fr; grid-column-gap: 48px"
          >
            <div class="d-flex justify-center align-center">
              <div style="max-height: 100%">
                <div class="text-center mb-8">
                  <v-icon size="80">
                    mdi-file-excel
                  </v-icon>
                </div>
                <div>
                  {{ selectFile.name }}
                </div>
              </div>
            </div>
            <div style="max-height: 250px; overflow: scroll">
              <div style="font-weight: bolder">
                {{ $t('numberOfNewAddDish') }}{{ newCategoryCount }}
              </div>
              <template v-if="newCategoryCount>0">
                <div
                  v-for="(cat,index) in newCategory"
                  :key="'newCat'+index"
                >
                  {{ cat.currentName.name }}
                </div>
              </template>
              <div class="font-weight-bold mt-2">
                {{ $t('numberOfNewAddPrinter') }} {{ newPrinterCount }}
              </div>
              <template v-if="newPrinterCount>0">
                <div
                  v-for="(p,index) in newPrinter"
                  :key="'printer'+index"
                >
                  {{ p.name }}
                </div>
              </template>
              <div class="font-weight-bold mt-2">
                {{ $t('numberOfNewAddDishes') }} {{ newDishCount }}
              </div>
              <template>
                <div
                  v-for="(d,index) in newDish"
                  :key="'dish'+index"
                >
                  {{ d.currentName.name }}
                </div>
              </template>
            </div>
          </div>
          <div class="d-flex justify-center">
            <p v-html="$t('wayToUploadFile')"/>
          </div>
          <div style="width: 100%; ">
            <v-file-input
              ref="input"
              accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              outlined
              style="opacity: 0; position: absolute; width: 100%; height: 120px; bottom: -70px; "
              type="file"
              @change="choseFile"
            />
          </div>
        </div>
      </div>

      <div class="text-center my-6">
        <p v-html="$t('chooseUploadFile')"/>
      </div>
      <div class="d-flex justify-center">
        <v-btn
          class="error mr-4"
          @click="closeDialog"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          class="primary"
          @click="uploadData"
        >
          {{ $t('importFile') }}
        </v-btn>
      </div>
    </div>

    <div
      v-else
      class="text-center"
    >
      <p class="text-h2 my-2">
        {{ $t('importFailed') }}
      </p>
      <div
        v-for="(error,index) in errors"
        :key="'error' + index "
        class="d-flex justify-start"
      >
        {{ error.row }} row: {{ error.message }}
      </div>

      <div class="my-6">
        <v-btn
          class="error"
          @click="closeDialog"
        >
          {{ $t('cancel') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>

  import IKUtils from 'innerken-js-utils'
  import { checkFileType, convertFileData, parseExcel, upload } from '../../../../common/readFile'
  import { isEmpty } from 'lodash'
  import { GlobalConfigLang } from '../../../../GlobalSettings'
  import { showSuccessMessage } from '@/common/utils'

  export default {
    name: 'UploadDishPage',
    components: {
      isEmpty,
    },
    props: {},
    data () {
      return {
        downloadFile: './public/file/上传模板202208.xlsx',
        clearDialog: false,
        selectFile: null,
        dragover: false,
        progress: 0,
        dragFileName: null,
        errors: [],

        categoryDict: null,
        printerDict: null,
        dishList: [],

      }
    },
    computed: {
      errorExist () {
        return this.errors.length > 0
      },

      newCategory () {
        return this.categoryDict ? Object.values(this.categoryDict)?.filter(it => it.add).map(item => {
          item.currentName = item.langs.find(i => i.lang === GlobalConfigLang.lang)
          return item
        }) : []
      },

      newCategoryCount () {
        return this.newCategory.length
      },
      printerList () {
        return this.printerDict ? Object.values(this.printerDict) : []
      },

      newPrinter () {
        return this.printerList?.filter(it => it.add) ?? 0
      },
      newPrinterCount () {
        return this.printerList.filter(it => it.add).length
      },

      newDish () {
        return this.dishList.map(item => {
          item.currentName = item.langs.find(i => i.lang === GlobalConfigLang.lang)
          return item
        }) ?? []
      },

      newDishCount () {
        return this.dishList.length
      },

    },
    watch: {

      selectFile (val) {
        if (val) {
          this.getUploadFile(val)
        }
      },
    },
    methods: {
      choseFile (event) {
        this.selectFile = event
      },
      onDrop (e) {
        this.dragover = false
        this.selectFile = e?.dataTransfer?.files?.item(0)
      },

      async getUploadFile (file) {
        if (!(await checkFileType(file))) {
          IKUtils.showError('File is not *.xls or *.xlsx')
          this.selectFile = null
          return
        }
        this.selectFile = file
        const rawFileData = await parseExcel(file)

        const res = await convertFileData(rawFileData)

        if (res.state === 'bad') {
          this.errors = res.errors
        } else {
          [this.categoryDict, this.printerDict, this.dishList] = [...Object.values(res.fetchedData)]
        }
      },

      closeDialog () {
        this.selectFile = null
        this.errors = []
        this.dragFileName = null
        this.$emit('close')
        IKUtils.toast(this.$t('cancel_success'), 'info')
      },

      async uploadData () {
        console.log(this.newCategory, 'this.newCategory', this.newPrinter, 'this.newPrinter', this.newDish, 'this.newDish')
        if (this.newCategoryCount === 0 && this.newPrinterCount === 0 && this.newDishCount === 0) {
          IKUtils.showConfirm('There is no item needed to be uploaded', 'Warning')
          return
        }

        this.$emit('successImport')
        await upload(this.categoryDict, this.printerDict, this.dishList)
        showSuccessMessage('导入工作结束！')
      },

    }
    ,
  }
</script>

<style scoped>

</style>
